import { array, bool, func } from 'prop-types'
import { PureComponent } from 'react'
import { kuiperClassNames, Menu, PopoverV2, renderIcon } from '@opallabs/kuiper'

import './styles.scss'

class UnassignedUser extends PureComponent {
  static propTypes = {
    disabled: bool,
    onAssignUser: func,
    onBlur: func,
    onFocus: func,
    people: array,
  }

  static defaultProps = {
    onAssignUser: () => {},
    people: [],
  }

  constructor(props) {
    super(props)
    this.state = {
      forceClosePopover: false,
      isUsingKeyboard: false,
    }
  }

  handleKeyPress = (e) => {
    e.stopPropagation()
    switch (e.which) {
      case 13:
        this.onEnterPressed()
        break
      default:
        break
    }
  }

  handleSearchKeyPress = (e) => {
    e.stopPropagation()
    switch (e.which) {
      case 27:
        this.onEscapePressed()
        break
      default:
        break
    }
  }

  onEnterPressed = () => {
    this.setState(
      () => ({ isUsingKeyboard: true }),
      () => {
        this.trigger.click()
      }
    )
  }

  onEscapePressed() {
    this.props.onFocus(this.state.isUsingKeyboard)
    if (this.state.isUsingKeyboard) {
      this.trigger.focus()
    }
    this.setState({ forceClosePopover: true })
  }

  onAfterPopoverOpen() {
    const inputElement = this.content.querySelector(
      'input.kuiper-input-element'
    )
    if (inputElement) inputElement.focus()
  }

  onAssignUser = (assignee) => {
    this.props.onFocus(this.state.isUsingKeyboard)
    const event = this.state.isUsingKeyboard ? 'keyPress' : 'click'
    this.setState(
      () => ({ forceClosePopover: true }),
      () => {
        this.props.onAssignUser(assignee, event)
      }
    )
  }

  onBeforePopoverClose = () => {
    this.setState({ isUsingKeyboard: false })
  }

  onClickTrigger = () => {
    this.setState({ isUsingKeyboard: false })
  }

  onFocus = () => {
    this.props.onFocus(this.state.isUsingKeyboard)
  }

  popoverContent() {
    return (
      <Menu
        avatared={true}
        options={this.props.people}
        optionsType="users"
        onSearchKeyDown={this.handleSearchKeyPress}
        onSelect={this.onAssignUser}
        role="listbox"
        searchable={true}
        searchIcon="plus"
        searchIconSize={8}
      />
    )
  }

  popoverTrigger() {
    /* eslint-disable jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-static-element-interactions */
    return (
      <div
        className={kuiperClassNames('unassignedUser-trigger')}
        onBlur={this.props.onBlur}
        onFocus={this.onFocus}
        onKeyPress={this.handleKeyPress}
        onMouseDown={this.onClickTrigger}
        ref={(trigger) => (this.trigger = trigger)}
        tabIndex={0}
      >
        <div className={kuiperClassNames('unassignedUser-icon')} tabIndex={-1}>
          {renderIcon('plus', {
            height: 10,
            width: 10,
            ariaLabel: 'Assign this task',
            ariaMode: 'presentational',
          })}
        </div>
      </div>
    )
    /* eslint-enable jsx-a11y/no-noninteractive-tabindex, jsx-a11y/no-static-element-interactions */
  }

  render() {
    if (this.props.disabled) {
      return <div className={kuiperClassNames('unassignedUser-disabled')} />
    }

    return (
      <PopoverV2
        className={kuiperClassNames(
          'unassignedUser',
          'user-picker-popover',
          'no-padding'
        )}
        content={this.popoverContent()}
        forceClose={this.state.forceClosePopover}
        onClose={this.onBeforePopoverClose}
        onOpened={this.onAfterPopoverOpen}
        position="bottom"
        trigger={this.popoverTrigger()}
      />
    )
  }
}

export default UnassignedUser
